import React from 'react';
/* eslint-disable */
export function Chat(props: React.ComponentPropsWithoutRef<'svg'>) {
  return (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M21 1L10 12M21 1L14 21L10 12M21 1L1 8L10 12"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
